import {
  all, call, put, takeLatest, select,
} from 'redux-saga/effects';
import { authRequest } from '../../helpers/request.helper';
import { constants } from '../actions/constants/fichaContactologica.constants';
import history from "../../history";
import {generatePath} from "react-router-dom";
import {ROUTE_PACIENTES_FILE} from "../../routes.constants";

function* getGraduaciones({ payload }: any) {
  const { pacienteId } = payload;
  // @ts-ignore
  const formDataContactologico = new FormData();
  formDataContactologico.append('consulta', JSON.stringify({ codigo_cliente: { valor: pacienteId } }));
  formDataContactologico.append('limite', '-1');
  formDataContactologico.append('orden', JSON.stringify({ fecha: 'DESC' }));

  const paramsContactologica = { url: 'api/graduacioncontactologica/buscar', method: 'POST', body: formDataContactologico };
  try {
    const { datos: datosContactologica } = yield call(authRequest, paramsContactologica);
    yield put({ type: constants.GET_GRADUACIONES_CONTACT_SUCCESS, payload: datosContactologica });
  } catch (error) {
    yield put({ type: constants.GET_GRADUACIONES_CONTACT_FAILURE, payload: error });
  }
}
const getTiendaId = (state: any) => state.auth.user.user_info.tienda_id;


function* getDatosFichaContactologica({ payload }: any) {
  // @ts-ignore
  const tiendaId: any = yield select(getTiendaId);
  const { codigo, tiendaGraduacion } = payload;

  const formData = new FormData();
  formData.append('consulta', JSON.stringify({
    tienda_id: {
      valor: tiendaGraduacion,
      operador: 'eq',
    },
    codigo: {
      valor: codigo,
      operador: 'eq',
    },
  }));
  formData.append('tipo_respuesta', 'mostrar');

  const params = {
    url: 'api/graduacioncontactologica/buscar',
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: graduaciones,
    } = yield call(authRequest, params);
    yield put({ type: constants.GET_GRADUACION_CONTACTOLOGICA_SUCCESS, payload: graduaciones[0] ? graduaciones[0] : null });
  } catch (error) {
    yield put({ type: constants.GET_GRADUACION_CONTACTOLOGICA_FAILURE, payload: error });
  }
}

function* getDatosUltimaOptometria({ payload }: any) {
  // @ts-ignore
  const tiendaId: any = yield select(getTiendaId);
  const { codigo } = payload;

  const formData = new FormData();
  formData.append('consulta', JSON.stringify({
    codigo: {
      valor: codigo,
      operador: 'eq',
    },
  }));
  formData.append('orden', JSON.stringify({
    id: 'DESC',
  }));
  formData.append('tipo_respuesta', 'mostrar');
  formData.append('limite', '1');

  const params = {
    url: 'api/graduacionoptometrica/buscar',
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: graduaciones,
    } = yield call(authRequest, params);
    yield put({ type: constants.GET_GRADUACION_ULTIMA_OPTOMETRIA_SUCCESS, payload: graduaciones[0] ? graduaciones[0] : null });
  } catch (error) {
    yield put({ type: constants.GET_GRADUACION_ULTIMA_OPTOMETRIA_FAILURE, payload: error });
  }
}

function* guardarDatosFichaContactologica({ payload }: any) {
  // @ts-ignore
  const tiendaId: any = yield select(getTiendaId);
  const { codigo, paciente_id } = payload;

  const formData = new FormData();
  formData.append('datos', JSON.stringify(payload));
  
  const params = {
    url: 'api/graduacioncontactologica/guardar',
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: respuesta,
    } = yield call(authRequest, params);
    sessionStorage.removeItem('infoPacienteActivityData');
    history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId:paciente_id }));
    yield put({ type: constants.GUARDAR_GRADUACION_CONTACTOLOGICA_SUCCESS, payload: respuesta });
  } catch (error) {
    yield put({ type: constants.GUARDAR_GRADUACION_CONTACTOLOGICA_FAILURE, payload: error });
  }
}

export default function* fichaContactologicaSaga() {
  yield all([
    takeLatest(constants.GET_GRADUACION_CONTACTOLOGICA_REQUEST, getDatosFichaContactologica),
    takeLatest(constants.GET_GRADUACION_ULTIMA_OPTOMETRIA_REQUEST, getDatosUltimaOptometria),
    takeLatest(constants.GET_GRADUACIONES_CONTACT_REQUEST, getGraduaciones),
    takeLatest(constants.GUARDAR_GRADUACION_CONTACTOLOGICA_REQUEST, guardarDatosFichaContactologica),
  ]);
}
